import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllBuckets({ payload }) {
  try {
    yield put(actions.addBucketLoading(true));
    const result = yield call(api.getAllBuckets);
    yield put(actions.getAllBucketsSuccess(result.data));
  } catch (error) {
    toast.error(error);
    yield put(actions.getAllBucketsFail());
  } finally {
    yield put(actions.addBucketLoading(false));
  }
}

//Edit Tables
function* editBucket({ payload }) {
  try {
    yield put(actions.addBucketLoading(true));
    const result = yield call(api.editBuckets, payload);
    console.log("first", result);
    yield put(actions.editBucketSuccess(result.data));
    toast.success("Edit Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.editBucketFail());
  } finally {
    yield put(actions.addBucketLoading(false));
  }
}
function* enableBucket({ payload }) {
  try {
    yield put(actions.addBucketLoading(true));
    yield call(api.enableBuckets, payload);
    yield put(actions.enableBucketSuccess(payload));
    toast.success("Edit Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.enableBucketFail());
  } finally {
    yield put(actions.addBucketLoading(false));
  }
}
// create
function* createBucket(formData) {
  try {
    yield put(actions.addBucketLoading(true));
    const result = yield call(api.createBuckets, formData.payload);
    yield put(
      actions.createBucketSuccess({
        data: result.data,
      })
    );
    toast.success("Created Successfully");
    formData?.action && formData?.action();
  } catch (error) {
    yield put(actions.createBucketFail());
  } finally {
    yield put(actions.addBucketLoading(false));
  }
}

function* deleteBucket({ payload }) {
  try {
    yield put(actions.addBucketLoading(true));
    yield call(api.deleteBucket, payload);
    yield put(actions.deleteBucketSuccess(payload));
    toast.success("Deleted Successfully");
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response);
    yield put(actions.deleteBucketFail());
  } finally {
    yield put(actions.addBucketLoading(false));
  }
}

function* restrictBucket({ payload }) {
  try {
    yield put(actions.addBucketLoading(true));
    const result = yield call(api.restrictBucket, payload);
    yield put(actions.restrictBucketSuccess(payload, result));
    toast.success("Restricted Successfully");
  } catch (error) {
    yield put(actions.restrictBucketFail());
  } finally {
    yield put(actions.addBucketLoading(false));
  }
}

export default function* SuperadminBucketSaga() {
  yield takeLatest(Types.GET_SUPERADMIN_BUCKETS_REQUEST, getAllBuckets);
  yield takeLatest(Types.EDIT_SUPERADMIN_BUCKET_REQUEST, editBucket);
  yield takeLatest(Types.ENABLE_SUPERADMIN_BUCKET_REQUEST, enableBucket);

  yield takeLatest(Types.CREATE_SUPERADMIN_BUCKET_REQUEST, createBucket);
  yield takeLatest(Types.DELETE_SUPERADMIN_BUCKET_REQUEST, deleteBucket);
  yield takeLatest(Types.RESTRICT_SUPERADMIN_BUCKET_REQUEST, restrictBucket);
}
